<template>
	<div>
		<div class="modal px-0 px-md-5" :id="id" tabindex="-1" role="dialog" :aria-labelledby="id + 'Label'" aria-hidden="true">
            <div class="modal-dialog mt-5 mx-auto" role="document">
                <div class="modal-content bg-dark text-white">
					<div class="modal-header">
						<button type="button" class="close text-light" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="mt-3 text-center">
						<h2 class="modal-title">
							App DRL là gì?
						</h2>
					</div>
					<div class="modal-body overflow-auto">
						<h5 class="font-italic">Là gì</h5>
						<div>
							<ul>
								<li>Các trường đại học thường có khái niệm "điểm rèn luyện" để khuyến khích sinh viên tham gia hoạt động do trường tổ chức</li>
								<li>Mỗi hoạt động có thể xếp vào các tiêu chí, sinh viên sẽ được công điểm rèn luyện khi tiêu chí có 1 hoạt động được xếp vào. Và tùy tiêu chí mà điểm cộng sẽ khác nhau</li>
								<br>
								<li>Vì 1 hoạt động có thể xếp vào nhiều tiêu chí, nếu không xếp đúng hoàn toàn có thể bị ít điểm hơn so với cách xếp tối ưu</li>
								<li>Công cụ này giúp sinh viên xếp hoạt động sao cho đạt điểm tối ưu nhất</li>
							</ul>
						</div>

						<hr>
						<h5 class="font-italic">Vì sao làm</h5>
						<div>
							<ul>
								<li>Ý tưởng làm app này nảy sinh khi tôi phải <i>xếp lịch học</i></li>
								<br>
								<ul>
									<li>Trang web của trường có hỗ trợ chấm điểm rèn luyện, nhưng phải chọn tiêu chí cho hoạt động thay vì hoạt động xếp vào tiêu chí. Điều đó dẫn đến rất khó xác định hoạt động nào nên xếp vào tiêu chí nào, nhất là khi có hoạt động và tiêu chí có quan hệ nhiều-nhiều</li>
									<br>
									<li>"Vì sao phải nhọc nhằn khi những thứ này máy sẽ làm tốt hơn mình nhiều", tôi đã nghĩ thế, và tôi bắt tay vào làm luôn</li>
								</ul>
								<br>
							</ul>
						</div>

						<hr>
						<h5 class="font-italic">Làm như nào</h5>
						<div>
							<ul>
								<li>Trước tiên, phải có dữ liệu, tôi mò các api của trang web trường và may mắn thay, các api tôi cần đều có thể dùng được, chỉ cần có api key</li>
								<br>
								<li>Sau khi có danh sách các hoạt động và danh sách các tiêu chí, tôi sắp xếp các hoạt động theo thứ tự "ưu tiên hoạt đông xếp được vào nhiều tiêu chí" và sắp xếp các tiêu chí "ưu tiên các tiêu chí nhiều điểm"</li>
								<br>
								<li>Rồi sau đó tôi dùng thuật toán tham lam, cứ nhét hết cho tràn điểm thì thôi</li>
								<br>
								<li>Về sau, tôi sử dụng thuật toán tối ưu hơn, tôi duyệt toàn bộ</li>
								<li>Tất nhiên, duyệt toàn bộ phải có cắt nhánh cận, và giảm bớt vòng lặp nhất có thể bằng cách dùng ánh xạ</li>
								<br>
								<li>À và để lấy dữ liệu từ server của trường, tôi phải gọi rất nhiều API cùng lúc, vì các dữ liệu cần phải có đủ mới tính toán được, mà gọi lần lượt 30 cái thì chờ đến tối, thế nên tôi đã sử dụng hàm Promise.all của javascript để đảm bảo code chỉ chạy khi có đủ hết dữ liệu, mà vẫn có thể gọi 30 API cùng lúc.</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
props: ['id'],
}
</script>

<style lang="css" scoped>
	img {
		width: 50%;
		border: 1px solid;
		border-radius: 5px;
	}
</style>